// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loni-checkbox[data-v-0012b6c5]{display:inline-flex;align-items:center;letter-spacing:1px;user-select:none;cursor:pointer}.loni-checkbox.disabled[data-v-0012b6c5]{cursor:not-allowed}.loni-checkbox>i[data-v-0012b6c5]{display:inline-block}.loni-checkbox>i.margin[data-v-0012b6c5]{margin-right:6px}", ""]);
// Exports
module.exports = exports;
